"use client";
import { ReactElement } from "react";
import type { ErrorBoundaryContextType } from "react-error-boundary";
import { AdvertisementTypeEnum } from "@app/types/enums";
import Advertisement from "@components/Advertisement/Advertisement";
import Footer from "@components/Footer/Footer";
import FooterSubscribeRow from "@components/Footer/FooterSubscribeRow/FooterSubscribeRow";
import Header from "@components/Header/Header";
import * as Sentry from "@sentry/react";
import { GoogleAdsSlotFactory } from "@util/helpers";

type CustomErrorProps = {
  errorMessage?: string;
} & Partial<ErrorBoundaryContextType> &
  Partial<Parameters<Sentry.FallbackRender>[0]>;

/**
 * Company: SPHMedia
 * @description: Base Component for Error
 * @argument { errorMessage } - is the custom error message to be displayed from SPH
 * @argument { error, componentStack, resetError } - are passed from Sentry ErrorBoundary
 * @see https://docs.sentry.io/platforms/javascript/guides/react/features/error-boundary/#examples
 * @argument { didCatch, error, resetErrorBoundary} - are passed from react-error-boundary
 * @see https://www.npmjs.com/package/react-error-boundary
 * @returns {ReactElement<CustomErrorProps>}
 */

export default function CustomError(): ReactElement<CustomErrorProps> {
  return (
    <>
      <Advertisement
        rootClassName="py-6"
        adUnitProps={{
          type: AdvertisementTypeEnum.LB1,
          slot: GoogleAdsSlotFactory.lb1("homepage"),
        }}
      />

      <Header />

      <div className="container px-3 py-3">
        <p className="mb-0 mt-3">The requested page could not be found.</p>
      </div>

      <FooterSubscribeRow />

      <Footer />
    </>
  );
}
